import { InjectionToken } from '@angular/core';
import { User } from './models/user.model';

export interface UserInfoResolver {
  resolve(): User;
}

export const INFO_USER_RESOLVER_TOKEN = new InjectionToken<UserInfoResolver>('INFO_USER_RESOLVER_TOKEN');
